import { WellnessScoreStatus } from "../../../Common/types";

export function getBmiStatus(bmi: number): WellnessScoreStatus {
  if (bmi < 16) return WellnessScoreStatus.NeedsSupport;
  if (bmi < 25) return WellnessScoreStatus.Healthy;
  if (bmi < 30) return WellnessScoreStatus.NeedsAttention;
  return WellnessScoreStatus.NeedsSupport;
}

export function getBmiDisplayValue(bmi: number): string {
  if (bmi % 1 === 0) return String(Math.round(bmi));
  return bmi.toFixed(2);
}
